import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { daysOfWeek } from "src/app/app.const";
import { Service } from "src/app/core/endpoints/models/service";
import { User } from "src/app/core/endpoints/models/user.model";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { AuthService } from "src/app/core/endpoints/auth.service";

@Component({
	selector: "app-services",
	templateUrl: "./services.component.html",
	styleUrls: ["./services.component.scss"],
})
export class ServicesComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;
	@ViewChild("fileInput") fileInput: any;

	public schedules: any[] = [];
	public services: Service[] = [];
	public loading: boolean = false;
	public dialogService: boolean = false;
	public serviceSelected: Service;
	public mode: "edit" | "register" = "edit";
	public photo: File[] = [];
	public stringPhoto: any[] = [];
	public mainPhoto: File;
	public mainStringPhoto: any;
	public photosToDelete: any[] = [];
	public daysOfWeek = daysOfWeek;
	public dialogSchedule: boolean = false;
	public cropping: boolean = false;
	public pictureCrop: any;
	public imageChangedEvent: any = "";
	loggedUser : any;

	form: FormGroup = this.fb.group({
		name: ["", Validators.required],
		images: [""],
		image: [""],
		price: ["", Validators.required],
		description: [""],
		deleted_photos: [""],
		is_default: [false],
	});

	constructor(
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		private apiService: ApiService,
		private fb: FormBuilder,
		private authService: AuthenticationService,
	) {
		this.loggedUser = this.authService.getUser();
	}

	ngOnInit(): void {
		this.loadServices();
	}
	
	getUser() {
		return AuthService.getDataUser();
	}

	/**
	 * Resetear formulario
	 */
	public resetForm() {
		this.form.reset();
		this.photo = undefined;
		this.stringPhoto = undefined;
		this.mainPhoto = undefined;
		this.mainStringPhoto = undefined;
		this.photosToDelete = undefined;
		this.pictureCrop = undefined;
	}
	/**
	 * Limpiar filtros de búsqueda
	 * @param table
	 */
	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}

	/**
	 * Mostrar modal de creación/edición de servicio
	 * @param service
	 */
	public showDialog(service?: any) {
		this.mode = service ? "edit" : "register";
		this.photo = [];
		this.stringPhoto = [];

		if (service) {
			this.photosToDelete = [];
			this.serviceSelected = service;
			this.form.patchValue(service);
			if (service.is_default){
				this.form.patchValue({
					is_default: true
				});
			}else{
				this.form.patchValue({
					is_default: false
				});
			}
			this.stringPhoto = service.images
				? service.images?.map((element) => ({
						id: element.id,
						image: element.image,
				  }))
				: [];
			this.pictureCrop = service.image;
		}
		this.dialogService = true;
	}

	/**
	 * Cargar listado de servicios
	 */
	public loadServices() {
		this.loading = true;
		this.apiService.getEntity("services").subscribe({
			next: (result) => {
				this.services = result.services;
				this.loading = false;
			},
			error: (err) => {
				console.log(err);
				this.loading = false;
				this.toast.show(
					"Error",
					"Ocurrió un error obteniendo el listado de servicios, inténtelo de nuevo",
					"error"
				);
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	/**
	 * Enviar formulario de registro/edición de servicio
	 */
	public async registerService() {
		this.form.markAllAsTouched();
		
		// if (this.stringPhoto.length === 0) {
		// 	return this.toast.show(
		// 		"Aviso",
		// 		"Añada al menos una imagen al carrusel",
		// 		"warn"
		// 	);
		// }

		// if (this.mainStringPhoto === null || this.mainStringPhoto === "") {
		// 	return this.toast.show("Aviso", "Añada una imagen principal", "warn");
		// }

		if (this.form.invalid) {
			console.log(this.form.errors);
			this.form.markAllAsTouched();
			return this.toast.show("Aviso", "Revise el formulario", "warn");
		}

		const formValue = this.form.value;
		const formData = new FormData();

		formData.append("name", formValue.name.toString());
		formData.append("price", formValue.price.toString());
		formData.append("description", formValue.description.toString());
		formData.append("is_default", formValue.is_default);
		formData.append("image", this.pictureCrop ? this.pictureCrop : '');
		for (const image of this.photo) {
			formData.append("images[]", image);
		}

		if (this.photosToDelete) {
			for (const image of this.photosToDelete) {
				formData.append("deleted_photo[]", image);
			}
		}
		this.loading = true;

		if (this.mode === "register") {
			this.apiService.addEntityFormData("registerService", formData).subscribe({
				next: (result) => {
					this.toast.show("Servicio registrado correctamente");
					this.loading = false;
					this.dialogService = false;
					this.cropping = false;
					this.loadServices();
				},
				error: (err) => {
					console.log(err);
					this.loading = false;
					this.cropping = false;
					this.toast.show(
						"Error",
						"Ocurrió un error al registrar el servicio, inténtelo de nuevo",
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		} else {
			formData.append("id", this.serviceSelected.id.toString());
			this.apiService.addEntityFormData("updateService", formData).subscribe({
				next: (result) => {
					this.toast.show("Servicio actualizado correctamente");
					this.loading = false;
					this.dialogService = false;
					this.cropping = false;
					this.loadServices();
				},
				error: (err) => {
					console.log(err);
					this.loading = false;
					this.cropping = false;
					this.toast.show(
						"Error",
						"Ocurrió un error al actualizar el servicio, inténtelo de nuevo",
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		}
	}

	/**
	 * Eliminar servicio seleccionado
	 */
	public deleteService(service: Service) {
		if (this.loading) return;
		this.confirmationService.confirm({
			header: 'Eliminar servicio',
			message: "¿Está seguro que desea eliminar este servicio?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.deleteEntity("deleteService", service.id).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Servicio eliminado correctamente");
						this.loadServices();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Aviso",
							"Ocurrió un error intentando eliminar el servicio, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}

	/**
	 * Manejador de imágenes
	 * @param $event
	 * @returns
	 */
	public handleUpload() {
		const files = this.fileInput.nativeElement.files;

		if (files && files.length) {
			for (let i = 0; i < files.length; i++) {
				const file = files[i];

				// Verificar el formato del archivo
				const allowedFormats = ["image/jpeg", "image/png"];
				if (allowedFormats.includes(file.type)) {
					// Verificar el número máximo de fotos
					if (this.stringPhoto.length < 5) {
						this.photo.push(file);
						const reader = new FileReader();
						reader.onload = (event: any) => {
							const imageUrl = event.target.result;
							this.stringPhoto.push({
								image: imageUrl,
							});
						};
						reader.readAsDataURL(file);
					} else {
						return this.toast.show(
							"Aviso",
							"Añada un máximo de cinco imágenes",
							"warn"
						);
					}
				} else {
					return this.toast.show(
						"Aviso",
						"El formato de la imagen debe ser PNG o JPG",
						"warn"
					);
				}
			}
		} else {
			console.log("No se seleccionaron imágenes.");
		}
	}

	/**
	 * Manejo de imagen principal
	 * @param $event
	 * @returns
	 */
	imageCropped(event: ImageCroppedEvent) {
		this.pictureCrop = event.base64;
	}

	imageLoaded(event: any) {}

	cropperReady() {}
	loadImageFailed() {}

	/**
	 * Manejador para imágen principal
	 * @param $event
	 * @returns
	 */
	public handleUploadPhoto(event: any) {
		this.imageChangedEvent = event;
		this.cropping = true;
	}

	/**
	 * Eliminar foto del formulario, galería
	 */
	public deletePhoto() {
		this.photo = [];
		this.stringPhoto = [];
		this.fileInput.nativeElement.value = "";
	}

	/**
	 * Eliminar foto main
	 */
	public deleteMainPhoto() {
		this.mainPhoto = undefined;
		this.mainStringPhoto = undefined;
		this.pictureCrop = undefined;
	}

	/**
	 * Push a array de imágenes eliminadas
	 * @param id
	 * @param index
	 */
	public deletePhotoCarrousel(id: number, index: number) {
		this.stringPhoto.splice(index, 1)[0];
		this.photosToDelete.push(id);
	}
}
